@if (multiple && !isDeselectOption) {
  <fmnts-pseudo-checkbox [state]="_selected() ? 'checked' : 'unchecked'" />
}

<ng-content select="[fmntsOptionPrefix]" />
<span #text class="fmnts-select-option__primary-text">
  <ng-content />
</span>
<ng-content select="[fmntsOptionSuffix]" />
